<template>
  <nav class="body__sidebar" id="body__sidebar" aria-label="Menú de la sección">
    <button
      v-if="role === 'admin'"
      type="button"
      class="back_company"
      @click="backCompany"
    >
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
      <span>Regresar</span>
    </button>
    <div class="nav-mob-resp">
      <hidden-arrow></hidden-arrow>
      <div class="title">
        <div class="title__icon" aria-hidden="true">
          <i class="fas fa-store"></i>
        </div>
        <div class="title__text">
          <h2 :title="company_name">{{ company_name }}</h2>
          <p>Datos comerciales</p>
        </div>
      </div>
      <div class="tabs">
        <router-link to="/" class="tab" :class="{ active: active === 'sucursales' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-globe"></i>
          </div>
          <div class="tab__text">
            <p>Sucursales</p>
          </div>
        </router-link>
        <router-link to="/products" class="tab" :class="{ active: active === 'productos' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-shopping-bag"></i>
          </div>
          <div class="tab__text">
            <p>Productos</p>
          </div>
        </router-link>
        <router-link to="/discount" class="tab" :class="{ active: active === 'descuentos' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-percentage"></i>
          </div>
          <div class="tab__text">
            <p>Descuentos</p>
          </div>
        </router-link>
        <router-link to="/usuarios-validadores" class="tab" v-if="role != 'admin'" :class="{ active: active === 'usuarios' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fa-solid fa-user"></i>
          </div>
          <div class="tab__text">
            <p>Usuarios</p>
          </div>
        </router-link>
        <router-link to="/IncidenciaAdmin" class="tab" v-if="role === 'admin'" :class="{ active: active === 'incidencias' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <div class="tab__text">
            <p>Incidencias</p>
          </div>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import HiddenArrow from '@/components/HiddenArrow.vue'

export default {
  name: 'CommercialSidebar',
  components: {
    HiddenArrow
  },
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      role: localStorage.getItem('role'),
      company_name: localStorage.getItem('company_name')
    }
  },
  methods: {
    backCompany() {
      localStorage.removeItem('admin_in_company')
      this.$router.push('/comercial')
    }
  }
}
</script>
